import React, { useRef, useEffect, useState } from 'react'
import './style.scss'

import { ButtonSave, ButtonSair, Form, Input } from './../../Form'

function Modal({
    title,
    load,
    onClose,
    onSave,
    validacao,
    data,
    nomeButtonSave = 'Salvar',
    children,
    showButtonSave = true,
    showButtonCancel = true,
    setWidth = '50%',
    isSidePanel = false
}) {

    const formRef = useRef()

    useEffect(() => {


        if (data && formRef?.current) {

            formRef.current.reset()
            if (data) {
                formRef.current.setData(data)
            }
        }

    }, [])

    useEffect(() => {

        document.body.classList.add('modal-open');

        return () => {

            // Se houver mais de um modal aberto (incluindo este que está desmontando), mantém a classe
            if (document.querySelectorAll('.modal.show').length > 1) {
                document.body.classList.add('modal-open');
            } else {
                document.body.classList.remove('modal-open');
            }
        }
    }, [])

    const [isClosing, setIsClosing] = useState(false)

    useEffect(() => {
        if (isClosing) {
            const timer = setTimeout(() => {
                if (onClose) onClose()
                setIsClosing(false)
            }, 300)
            return () => clearTimeout(timer)
        }
    }, [isClosing, onClose])

    function _onClose() {

        if (load) return

        setIsClosing(true)
    }

    const modalClass = `modal fade show ${isSidePanel ? 'side-panel' : ''} ${isClosing ? 'closing' : ''}`;

    return (
        <>
            <Form setRef={formRef} onSubmit={onSave} validacao={validacao} >
                <div className={modalClass}>
                    <div className="modal-dialog" style={{ width: setWidth }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0" id="myLargeModalLabel">{title}</h5>
                                {showButtonCancel && <button onClick={_onClose} type="button" className="close">×</button>}
                            </div>
                            <div className="modal-body">

                                <div className="row">
                                    <Input name='id' hidden col='col-lg-12' />
                                </div>

                                {children}
                            </div>
                            <div className="modal-footer">
                                {
                                    showButtonCancel &&
                                    <ButtonSair name='Sair' onClick={_onClose} type='button' />
                                }
                                {
                                    showButtonSave &&
                                    <ButtonSave load={load} name={nomeButtonSave} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}

export default Modal